import { configs } from "@/configs";
import { api } from "@/client/api";

export async function sendLineLogin(): Promise<void> {
  await api.post(`${configs.apiUrl}/line/login-success`);
}
